<script>
  import { createEventDispatcher } from "svelte";
  import classNames from "../../utils/classNames";
  import RenderToggleButton from "../button/RenderToggleButton.svelte";
  import CustomIcon from "../CustomIcon.svelte";

  const dispatch = createEventDispatcher();

  export let actions = [];
  export let row;
  export let disabled = false;

  function handleClick(action) {
    if (action.run) {
      action?.run?.(row);
    } else {
      dispatch("actionClick", { action, row });
    }
  }
</script>

<div>
  {#each actions as a}
    {#if !a.hidden}
      <span
        role={a.type}
        on:click|preventDefault={() => handleClick(a)}
        class={classNames(
          `rounded cursor-pointer inline-block border border-transparent
         focus:outline-none focus:border-gray-800 focus:shadow-outline-gray px-1
         ${disabled && "cursor-default"}
        `
        )}
      >
        {#if a.key === "activate"}
          <RenderToggleButton active={!row[a.name]} />
        {:else}
          <CustomIcon
            {disabled}
            name={a.icon}
            label={a.label}
            color="#B2833F"
            height={18}
            width={18}
          />
        {/if}
      </span>
    {/if}
  {/each}
</div>
